import { forwardRef } from 'react';

import { Table, TableBody } from '@/common/components/ui/table';
import { ValidableSection } from '@/policy/component/Validation/ValidableSection';
import { FinancialDataSection } from '@/policy/types/PolicyCoverage';
import { ValidationResult } from '@/policy/types/ValidationResult';

import { FinancialDataTableHeader } from './FinancialDataTableHeader';
import { FinancialDataTableRows } from './FinancialDataTableRows';

export type FinancialDataSummarySectionProps = {
  section: FinancialDataSection;
  validation: ValidationResult;
  onValidationChange: (validation: ValidationResult) => void;
  isSelected: boolean;
  onTableClick: (sectionUuid: string) => void;
};

export const FinancialDataSummarySection = forwardRef<
  HTMLDivElement,
  FinancialDataSummarySectionProps
>(
  (
    { section, validation, onValidationChange, isSelected, onTableClick },
    ref,
  ) => {
    return (
      <ValidableSection
        ref={ref}
        sectionIdentifier={section.identifier}
        validation={validation}
        onValidationChange={onValidationChange}
        isSelected={isSelected}
        onTableClick={onTableClick}
      >
        <Table>
          <FinancialDataTableHeader />
          <TableBody>
            <FinancialDataTableRows rows={section.rows} />
          </TableBody>
        </Table>
      </ValidableSection>
    );
  },
);
